export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M21 5H7v2h14zm0 5H7v5h14zm2-5v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5c0-1.11.89-2 2-2h14a2 2 0 0 1 2 2M3 19h15v2H3a2 2 0 0 1-2-2V8h2z\"/>"
};